import { useTranslation } from 'react-i18next';

//Components
import MiceCard from "../../components/Mice/MiceCard";

//Images
import meetingsImg from '../../assets/images/mice/MICE-meeting-dt@2x.jpg';
import incentivesImg from '../../assets/images/mice/MICE-incentives-dt@2x.jpg';
import congressImg from '../../assets/images/mice/MICE-congress-dt@2x.jpg';
import eventsImg from '../../assets/images/mice/MICE-events-dt@2x.jpg';

//Intersection
import { useInView } from 'react-intersection-observer'


const MiceCards = () => {

    const { t } = useTranslation();

    const [miceCards, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    })

    return (

        <section className={`incoming-mice__cards animate slide-up ${inView ? 'in-view' : ''}`} ref={miceCards}>
            <MiceCard 
            title={t("mice.cards.title1")}
            img={meetingsImg}
            />
            <MiceCard 
            title={t("mice.cards.title2")}
            img={incentivesImg}
            />
            <MiceCard 
            title={t("mice.cards.title3")}
            img={congressImg}
            />
            <MiceCard 
            title={t("mice.cards.title4")}
            img={eventsImg}
            />
        </section>
    )
}

export default MiceCards